import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Youtube, Mail, MapPin, MessageCircle } from 'lucide-react';
import { COMPANY, SOCIAL } from '../pages/legal/company';

const Footer = () => (
  <footer className="bg-[#0a0a0b] text-white/80 pt-16 pb-8">
    <div className="max-w-6xl mx-auto px-4 grid md:grid-cols-4 gap-10">
      <div>
        <div className="flex items-center gap-2">
          <img
            src="/images/logo_plus_site.webp"
            alt="PlusPlus"
            className="h-8 w-auto object-contain"
          />
        </div>
        <p className="mt-4 text-sm text-white/60 leading-relaxed">
          Cartão de visita eletrônico. Compartilhe seu contato com um toque.
        </p>
        <div className="mt-5 flex items-center gap-3">
          {[['instagram', Instagram, 'Instagram'], ['facebook', Facebook, 'Facebook'], ['youtube', Youtube, 'YouTube']]
            .filter(([k]) => SOCIAL[k])
            .map(([k, Icon, label]) => (
              <a key={k} href={SOCIAL[k]} target="_blank" rel="noopener noreferrer" aria-label={label} className="w-9 h-9 rounded-full bg-white/5 hover:bg-white/10 flex items-center justify-center transition"><Icon className="w-4 h-4" /></a>
            ))}
        </div>
      </div>

      <div>
        <p className="font-semibold text-white">Produtos</p>
        <ul className="mt-4 space-y-2 text-sm">
          <li><a href="/produtos/cartao-de-visita-digital-personalizado/" className="hover:text-white transition">Cartão Personalizado</a></li>
          <li><a href="/produtos/cartao-de-visita-de-metal-nfc/" className="hover:text-white transition">Cartão Metal</a></li>
          <li><a href="/produtos/cartao-de-visita-bambu-nfc/" className="hover:text-white transition">Cartão Bamboo</a></li>
          <li><a href="/produtos/adesivo-nfc-tag/" className="hover:text-white transition">Adesivo Tag</a></li>
          <li><a href="/produtos/" className="hover:text-white transition">Todos os produtos</a></li>
        </ul>
      </div>

      <div>
        <p className="font-semibold text-white">Empresa</p>
        <ul className="mt-4 space-y-2 text-sm">
          <li><Link to="/corporativo" className="hover:text-white transition">Para empresas</Link></li>
          <li><a href="/blog/" className="hover:text-white transition">Blog</a></li>
          <li><a href="/para/" className="hover:text-white transition">Para profissionais</a></li>
          <li><a href="/comparativo/" className="hover:text-white transition">Comparativos</a></li>
          <li><a href="/#revendedor" className="hover:text-white transition">Revendedor</a></li>
          <li><a href="/#faq" className="hover:text-white transition">FAQ</a></li>
          <li><Link to="/politicas" className="hover:text-white transition">Política de Privacidade</Link></li>
          <li><Link to="/termos-uso" className="hover:text-white transition">Termos de Uso</Link></li>
          <li><Link to="/lgpd" className="hover:text-white transition">LGPD</Link></li>
        </ul>
      </div>

      <div>
        <p className="font-semibold text-white">Contato</p>
        <ul className="mt-4 space-y-3 text-sm">
          <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5 text-[#2FE596] shrink-0" /><a href={`mailto:${COMPANY.email}`} className="hover:text-white transition break-all">{COMPANY.email}</a></li>
          <li className="flex items-start gap-2"><MessageCircle className="w-4 h-4 mt-0.5 text-[#2FE596] shrink-0" /><a href="https://wa.me/554131800650" target="_blank" rel="noopener noreferrer" className="hover:text-white transition">{COMPANY.whatsapp}</a></li>
          <li className="flex items-start gap-2">
            <MapPin className="w-4 h-4 mt-0.5 text-[#2FE596] shrink-0" />
            <address className="not-italic">
              {COMPANY.street}<br />{COMPANY.district}, {COMPANY.city} - {COMPANY.state}<br />CEP {COMPANY.zip}
            </address>
          </li>
        </ul>
      </div>
    </div>

    <div className="max-w-6xl mx-auto px-4 mt-12 pt-6 pb-2 md:pr-20 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
      <div>© {new Date().getFullYear()} PlusPlus. Todos os direitos reservados.</div>
      <div className="flex items-center gap-5">
        <Link to="/termos-uso" className="hover:text-white/80">Termos de Uso</Link>
        <Link to="/politicas" className="hover:text-white/80">Política de Privacidade</Link>
        <Link to="/lgpd" className="hover:text-white/80">LGPD</Link>
        <button type="button" onClick={() => window.dispatchEvent(new Event('pp:cookie-prefs'))} className="hover:text-white/80">Preferências de cookies</button>
      </div>
    </div>
  </footer>
);

export default Footer;
